var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState, useContext } from 'react';
import { useQuery } from '@apollo/client';
import CardSection from '../ContentSystem/components/CardSection/CardSection';
import TableSection from '../ContentSystem/components/TableSection/TableSection';
import ErrorBoundary from '../ErrorBoundary/ErrorBoundary';
import { SIZE_GUIDE_MODAL } from './SizeGuideModal.gql';
import OverlayModal from '../ContentSystem/components/OverlayModal/OverlayModal';
import { QuickViewContext } from '../QuickView/QuickView.context';
import * as Styled from './SizeGuideModal.styled';
/**
 * `SizeGuideModal` displays all details about a product inside a modal.
 */
export var SizeGuideModal = function (_a) {
    var _b = _a.isOpen, isOpen = _b === void 0 ? false : _b, _c = _a.onRequestClose, onRequestClose = _c === void 0 ? undefined : _c, guides = _a.guides;
    var _d = useState(0), currentGuideIndex = _d[0], setCurrentGuideIndex = _d[1];
    var options = guides.map(function (guide) { return ({
        label: guide.content.label
    }); });
    var isQuickView = useContext(QuickViewContext).isQuickView;
    var handleSelectSlide = function (event) {
        setCurrentGuideIndex(Number(event.target.value));
    };
    return (React.createElement(OverlayModal, { header: "Size Guide", isOpen: isOpen, onRequestClose: onRequestClose, modalType: "peeking", slides: options, onSelectSlide: handleSelectSlide, selectedSlide: currentGuideIndex, size: "mega", withPadding: false, height: isQuickView ? '85vh' : 'auto' },
        React.createElement(Styled.SizeGuideModal, null, guides[currentGuideIndex].content.sections.map(function (section, index) {
            var renderSection = function (sectionData) {
                var _a;
                switch (sectionData.__typename) {
                    case 'CardSection':
                        return React.createElement(CardSection, __assign({ key: index }, sectionData));
                    case 'TableSection':
                        return React.createElement(TableSection, __assign({ key: index }, sectionData));
                    case 'SectionContainer':
                        return (_a = sectionData.sections) === null || _a === void 0 ? void 0 : _a.map(function (nestedSection, nestedIndex) {
                            return renderSection(__assign(__assign({}, nestedSection), { key: "".concat(index, "-").concat(nestedIndex) }));
                        });
                    default:
                        return null;
                }
            };
            return renderSection(section);
        }))));
};
/**
 * `SizeGuideModal` component wrapped with data fetching.
 */
var SizeGuideModalWithData = function (_a) {
    var query = _a.query, props = __rest(_a, ["query"]);
    var _b = useQuery(SIZE_GUIDE_MODAL, {
        variables: {
            query: query.map(function (_a) {
                var __typename = _a.__typename, item = __rest(_a, ["__typename"]);
                return item;
            })
        },
        context: {
            withCacheKey: true
        }
    }), data = _b.data, error = _b.error;
    if (!data || error)
        return null;
    return (React.createElement(ErrorBoundary, null,
        React.createElement(SizeGuideModal, __assign({ guides: data.sizeGuides }, props))));
};
export default SizeGuideModalWithData;
